var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeActive = function SvgMeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M24 26c7.18 0 13-5.82 13-13S31.18 0 24 0 11 5.82 11 13s5.82 13 13 13m-11 4h22c7.18 0 13 5.82 13 13s-5.82 13-13 13H13C5.82 56 0 50.18 0 43s5.82-13 13-13"
  })));
};
export default SvgMeActive;